/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { BREAKPOINTS } from '@/constants';
import { ensureArray } from '@/utils';
import './style.less';
export default tsx.component({
    functional: true,
    props: {
        columnsXLarge: p(Number).optional,
        columnsLarge: p(Number).optional,
        columnsMedium: p(Number).optional,
        columnsSmall: p(Number).optional,
        colsOverride: p.ofType().optional,
        masonryGutter: p(Number).optional,
        noStyling: p(Boolean).default(false),
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(h, ctx) {
        const columnsSmall = ctx.props.columnsSmall ?? 1;
        const columnsMedium = ctx.props.columnsMedium ?? columnsSmall;
        const columnsLarge = ctx.props.columnsLarge ?? columnsMedium;
        const columnsXLarge = ctx.props.columnsXLarge ?? columnsLarge;
        const cols = {
            default: columnsXLarge,
            [BREAKPOINTS.xlargeWidth - 1]: columnsLarge,
            [BREAKPOINTS.largeWidth - 1]: columnsMedium,
            [BREAKPOINTS.mediumWidth - 1]: columnsSmall,
            ...ctx.props.colsOverride,
        };
        const body = ensureArray(ctx.slots().default);
        const cls = [ctx.data.class, ctx.data.staticClass, ctx.props.noStyling ? '' : 'cg-masonry'];
        return (<masonry cols={cols} class={cls} columnClass="column" gutter={ctx.props.masonryGutter}>
                {...body}
            </masonry>);
    },
});
